import ngModule from './mun-doc-module';
// Import modules with registrations
import './endpoints';
import './io';
import './schemas';
import './search';
import './travesty';

export default ngModule.name;
